<template>
    <v-dialog v-model="smsModal" max-width="500px">
        <v-card>
            <div class="modal-header">
                <h4  class="modal-headline">{{ $page.props.lang.new_sms || 'New SMS' }}</h4>
                <v-btn icon @click="smsModal = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div>
                <v-card-text>
                    <v-container>
                        <v-alert v-if="responseErrors.credit" type="error">
                            <span v-for="item in responseErrors.credit" :key="item">{{item}}</span>
                        </v-alert>
                        <div>
                            <div class="form-group">
                              <label class="custom-label">{{ $page.props.lang.send_to || 'Send to' }}</label>
                              <v-select v-model="message.member_type" 
                              :items="memberTypes" 
                              text="text" 
                              value="value" outlined dense 
                             :error-messages="responseErrors.member_type" 
                             :hide-details="!responseErrors.member_type"></v-select>
                            </div>
                            <div class="form-group">
                                <v-row>
                                    <v-col style="padding:0 12px">
                                        <label class="custom-label">{{ $page.props.lang.message || 'Enter your message:' }}</label>
                                    </v-col>
                                    <v-col style="padding:0 12px">
                                          <p class="text-right" >{{messageStatus.length}}/{{messageStatus.messages}}</p>
                                    </v-col>
                                </v-row>
                                <v-textarea v-model="message.content" outlined dense style="margin-bottom:10px;"
                                    :error-messages="responseErrors.content" 
                                    :hide-details="!responseErrors.content"></v-textarea>
                                <v-btn @click="addPlaceholder('{first_name}')" x-small color="primary">{{$page.props.lang.first_name || "First name"}}</v-btn> 
                                <v-btn @click="addPlaceholder('{last_name}')" x-small color="primary">{{$page.props.lang.last_name || "Last name"}}</v-btn>
                            </div>   
                        </div>
                        <v-card-actions>
                            <span>{{ $page.props.lang.sms_credit || "SMS Credit" }}: {{sms_credit | round(2)}}</span>
                            <v-spacer></v-spacer>
                            <v-btn color="regular" @click="smsModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn color="primary" @click="sendSms()" :loading="sending">{{ $page.props.lang.send || "Send" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import { VueEditor, Quill } from "vue2-editor";
import SmsCount from "./../../../../plugins/smsCount";
import throttle from 'lodash/throttle'
import EventBus from '@/js/eventbus'

export default {
    components: { VueEditor },
    props: {
        open: Boolean,
        sms_credit: Number
    },

    data(){
      return {
        message:{
              member_type:'',
              content:''
            },
        messageStatus: {
            length: 0,
            messages: 1,
            per_message: 160,
            remaining: 160
        },
        memberTypes: [
            { value: '0', text: this.$page.props.lang.to_all || 'All'},
            { value: '1', text: this.$page.props.lang.to_active || 'Active'},
            { value: '2', text: this.$page.props.lang.to_inactive || 'Inactive'},
        ],
        sending: false,
        responseErrors:{},
        customToolbar: [''],
        editorOptions: {
            modules: {
                toolbar: false,
            },
        }
      }
    },
    computed: {
        smsModal: {
            get: function() {
                return this.open
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    },
    watch: {
        'message.content': {
            handler: throttle(function(value) {
               this.messageStatus = SmsCount.count(value);
            }, 250)
        }
    },
    methods: {
        addPlaceholder(placeholder){
            this.message.content += placeholder;
        },
        sendSms() {
            this.sending = true;
            axios.post('/backoffice/messages/sendSms', this.message)
                .then(response => {
                    var color = 'success';
                    this.sending = false;
                    if(response.data.status==="OK") {
                        
                        this.smsModal = false;
                    } else {
                        color = 'error';
                    }

                    EventBus.$emit('SHOW_NOTIFICATION',{
                        message: response.data.message,
                        color: color,
                        timeout: 5000
                   })

                })
                .catch(error => {
                    this.sending = false;
                    EventBus.$emit('SHOW_NOTIFICATION',{
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });
        }
    }
}
</script>
